<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Final Pricing Details</span>
            <span>
                      <el-button class="white-btn" size="small" @click="logs=true;">Logs</el-button>

                      <el-button class="white-btn ml-2" size="small" @click="edit=true;editdet()">Edit</el-button>


            </span>
         </template>

        <div v-if="enquiry.permissions.pricingdetails.view">

            <!-- ── Flight Section ── -->
            <template v-if="(enquiry.finalquotation && enquiry.finalquotation.flight_includes) || enquiry.is_flight">
                <div class="pricing-section-title">Flight Pricing</div>
                <el-descriptions size="small" direction="vertical" :column="10" border>
                    <el-descriptions-item label="Quoted Flight Total (Ref)">{{ fmt(quotedFlightTotal) }}</el-descriptions-item>
                    <el-descriptions-item label="Actual Flight Booking Cost">{{ fmt(enquiry.bookingdetails.flight_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Flight GST (18%)">{{ fmt(enquiry.bookingdetails.flight_gst) }}</el-descriptions-item>
                    <el-descriptions-item label="Flight Profit">{{ fmt(enquiry.bookingdetails.flight_profit) }}</el-descriptions-item>
                </el-descriptions>
            </template>

            <!-- ── Package Section ── -->
            <template v-if="hasPackage">
                <div class="pricing-section-title mt-2">Package Pricing</div>
                <el-descriptions size="small" direction="vertical" :column="10" border>
                    <el-descriptions-item label="Quoted Package Total (Ref)">{{ fmt(quotedPackageTotal) }}</el-descriptions-item>
                    <el-descriptions-item label="Land package discount" v-if="packageDiscountBreakup.landDiscount > 0">
                        {{ fmt(packageDiscountBreakup.landDiscount) }}
                        <small v-if="packageDiscountBreakup.type === 'percent'">({{ packageDiscountBreakup.value }}%)</small>
                    </el-descriptions-item>
                    <el-descriptions-item label="GST discount" v-if="packageDiscountBreakup.gstDiscount > 0">
                        {{ fmt(packageDiscountBreakup.gstDiscount) }}
                    </el-descriptions-item>
                    <el-descriptions-item label="Hotel Cost" v-if="enquiry.bookingdetails.hotel_cost>0">{{ fmt(enquiry.bookingdetails.hotel_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Visa Cost" v-if="enquiry.bookingdetails.visa_cost>0">{{ fmt(enquiry.bookingdetails.visa_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Land Cost" v-if="enquiry.bookingdetails.land_cost>0">{{ fmt(enquiry.bookingdetails.land_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Cruise Cost" v-if="enquiry.bookingdetails.cruise_cost>0">{{ fmt(enquiry.bookingdetails.cruise_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Travel Insurance" v-if="enquiry.bookingdetails.travel_insurance_cost>0">{{ fmt(enquiry.bookingdetails.travel_insurance_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="TCS (2%)" v-if="enquiry.bookingdetails.tds_cost>0">{{ fmt(enquiry.bookingdetails.tds_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Package GST (5%)">{{ fmt(enquiry.bookingdetails.land_gst) }}</el-descriptions-item>
                    <el-descriptions-item label="Package Profit">{{ fmt(enquiry.bookingdetails.land_profit) }}</el-descriptions-item>
                    <el-descriptions-item label="Hotel Profit" v-if="enquiry.bookingdetails.hotel_profit>0">{{ fmt(enquiry.bookingdetails.hotel_profit) }}</el-descriptions-item>
                    <el-descriptions-item label="Transportation Cost" v-if="enquiry.bookingdetails.transportation_cost>0">{{ fmt(enquiry.bookingdetails.transportation_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Transportation Profit" v-if="enquiry.bookingdetails.transportation_profit>0">{{ fmt(enquiry.bookingdetails.transportation_profit) }}</el-descriptions-item>
                    <el-descriptions-item label="Backup Cost" v-if="enquiry.bookingdetails.backup_cost>0">{{ fmt(enquiry.bookingdetails.backup_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Service Cost" v-if="enquiry.bookingdetails.service_cost>0">{{ fmt(enquiry.bookingdetails.service_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Land Before GST" v-if="enquiry.bookingdetails.land_before_gst>0">{{ fmt(enquiry.bookingdetails.land_before_gst) }}</el-descriptions-item>
                    <el-descriptions-item label="Helicopter Cost" v-if="enquiry.bookingdetails.helicopter_cost>0">{{ fmt(enquiry.bookingdetails.helicopter_cost) }}</el-descriptions-item>
                    <el-descriptions-item label="Helicopter Profit" v-if="enquiry.bookingdetails.helicopter_profit>0">{{ fmt(enquiry.bookingdetails.helicopter_profit) }}</el-descriptions-item>
                    <el-descriptions-item label="Helicopter GST" v-if="enquiry.bookingdetails.helicopter_gst>0">{{ fmt(enquiry.bookingdetails.helicopter_gst) }}</el-descriptions-item>
                    <el-descriptions-item label="Helicopter Total" v-if="enquiry.bookingdetails.helicopter_total>0">{{ fmt(enquiry.bookingdetails.helicopter_total) }}</el-descriptions-item>
                </el-descriptions>
            </template>

            <!-- ── Summary ── -->
            <div class="pricing-section-title mt-2">Summary</div>
            <el-descriptions size="small" direction="vertical" :column="10" border>
                <el-descriptions-item label="Total GST">{{ fmt(enquiry.bookingdetails.gst) }}</el-descriptions-item>
                <el-descriptions-item label="Total Profit">{{ fmt(enquiry.bookingdetails.profit) }}</el-descriptions-item>
                <el-descriptions-item label="Quote Price">{{ fmt(enquiry.bookingdetails.quote_price) }}</el-descriptions-item>
                <el-descriptions-item label="Discount" v-if="enquiry.bookingdetails.discount_amount>0">
                    {{ fmt(enquiry.bookingdetails.discount_amount) }}
                    <small v-if="enquiry.bookingdetails.discount_type==='percent'">
                        ({{ enquiry.bookingdetails.discount_value }}%)
                    </small>
                </el-descriptions-item>
                <el-descriptions-item label="Effective Quote" v-if="enquiry.bookingdetails.discount_amount>0 && enquiry.bookingdetails.land_after_discount == null">
                    {{ fmt((enquiry.bookingdetails.quote_price || 0) - (enquiry.bookingdetails.discount_amount || 0)) }}
                </el-descriptions-item>
                <el-descriptions-item label="Discount Reason" v-if="enquiry.bookingdetails.discount_reason">
                    {{ enquiry.bookingdetails.discount_reason }}
                </el-descriptions-item>
            </el-descriptions>

            <!-- ── Sales (flat cost snapshot) ── -->
            <div class="pricing-section-title mt-2">Sales</div>
            <el-descriptions size="small" direction="vertical" :column="10" border>
                <el-descriptions-item label="Quote Price">{{ fmt(enquiry.bookingdetails.quote_price) }}</el-descriptions-item>
                <el-descriptions-item label="Hotel Cost" v-if="enquiry.bookingdetails.hotel_cost>0">{{ fmt(enquiry.bookingdetails.hotel_cost) }}</el-descriptions-item>
                <el-descriptions-item label="Flight Cost" v-if="enquiry.bookingdetails.flight_cost>0">{{ fmt(enquiry.bookingdetails.flight_cost) }}</el-descriptions-item>
                <el-descriptions-item label="Visa Cost" v-if="enquiry.bookingdetails.visa_cost>0">{{ fmt(enquiry.bookingdetails.visa_cost) }}</el-descriptions-item>
                <el-descriptions-item label="Land Cost" v-if="enquiry.bookingdetails.land_cost>0">{{ fmt(enquiry.bookingdetails.land_cost) }}</el-descriptions-item>
                <el-descriptions-item label="Cruise Cost" v-if="enquiry.bookingdetails.cruise_cost>0">{{ fmt(enquiry.bookingdetails.cruise_cost) }}</el-descriptions-item>
                <el-descriptions-item label="Travel Insurance" v-if="enquiry.bookingdetails.travel_insurance_cost>0">{{ fmt(enquiry.bookingdetails.travel_insurance_cost) }}</el-descriptions-item>
                <el-descriptions-item label="Discount" v-if="enquiry.bookingdetails.discount_amount>0">{{ fmt(enquiry.bookingdetails.discount_amount) }}</el-descriptions-item>
                <el-descriptions-item label="GST">{{ fmt(enquiry.bookingdetails.gst) }}</el-descriptions-item>
                <el-descriptions-item label="Profit">{{ fmt(salesProfit) }}</el-descriptions-item>
            </el-descriptions>

        </div>

        <el-descriptions
            v-for="lgp in enquiry.lockedpricedetaillogs"
            :title="lgp.department"
            size="small"
            direction="vertical"
            :column="10"
            border
            class="mt-2"
        >
            <el-descriptions-item label="Quote Price">{{ fmt(lgp.quote_price) }}</el-descriptions-item>
            <el-descriptions-item label="Hotel Cost" v-if="lgp.hotel_cost>0">{{ fmt(lgp.hotel_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Flight Cost" v-if="lgp.flight_cost>0">{{ fmt(lgp.flight_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Visa Cost" v-if="lgp.visa_cost>0">{{ fmt(lgp.visa_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Land Cost" v-if="lgp.land_cost>0">{{ fmt(lgp.land_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Cruise Cost" v-if="lgp.cruise_cost>0">{{ fmt(lgp.cruise_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Travel Insurance" v-if="lgp.travel_insurance_cost>0">{{ fmt(lgp.travel_insurance_cost) }}</el-descriptions-item>
            <el-descriptions-item label="TCS" v-if="lgp.tds_cost>0">{{ fmt(lgp.tds_cost) }}</el-descriptions-item>
            <el-descriptions-item label="Discount" v-if="lgp.discount_amount>0">{{ fmt(lgp.discount_amount) }}</el-descriptions-item>
            <el-descriptions-item label="Discount Reason" v-if="lgp.discount_reason">{{ lgp.discount_reason }}</el-descriptions-item>
            <el-descriptions-item label="GST">{{ fmt(lgp.gst) }}</el-descriptions-item>
            <el-descriptions-item label="Profit (Non-Flight)" v-if="lgp.land_profit>0">{{ fmt(lgp.land_profit) }}</el-descriptions-item>
            <el-descriptions-item label="Profit (Flight)" v-if="lgp.flight_profit>0">{{ fmt(lgp.flight_profit) }}</el-descriptions-item>
            <el-descriptions-item label="Profit">{{ fmt(lgp.profit) }}</el-descriptions-item>
        </el-descriptions>

    </el-card>

    <el-drawer v-model="edit" direction="rtl">
        <template #header>
            <h4>Edit Pricing Details</h4>
        </template>
        <template #default>
            <el-form
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"
            >

                <!-- ══ FLIGHT SECTION ══ -->
                <template v-if="(enquiry.finalquotation && enquiry.finalquotation.flight_includes) || enquiry.is_flight">
                    <el-divider content-position="left"><strong>Flight Section</strong></el-divider>

                    <el-form-item label="Quoted Flight Total (Reference)">
                        <el-input :value="fmt(quotedFlightTotal)" readonly />
                        <!-- <small class="el-form-item__hint">= Flight Cost + Flight GST + Flight Profit from Quotation</small> -->
                    </el-form-item>

                    <el-form-item label="Actual Flight Booking Amount" prop="flight_cost">
                        <el-input type="number" min="0" v-model="form.flight_cost" @change="calculateconvertprofit" placeholder="Amount actually paid for flight" />
                    </el-form-item>

                    <el-form-item :label="'Flight GST (' + (pricingRates.flight_gst || 18) + '%)'">
                        <el-input type="number" v-model="form.flight_gst" placeholder="Flight GST" readonly />
                        <!-- <small class="el-form-item__hint">y × 18/118 &nbsp; (y = Quoted Total − Actual Booking)</small> -->
                    </el-form-item>

                    <el-form-item label="Flight Profit">
                        <el-input type="number" v-model="form.flight_profit" placeholder="Flight Profit" readonly />
                        <!-- <small class="el-form-item__hint">y × 100/118</small> -->
                    </el-form-item>
                </template>

                <!-- ══ PACKAGE SECTION ══ -->
                <template v-if="hasPackage">
                    <el-divider content-position="left"><strong>Package Section</strong></el-divider>

                    <el-form-item label="Quoted Package Total (Reference)">
                        <el-input :value="fmt(quotedPackageTotal)" readonly />
                        <!-- <small class="el-form-item__hint">= Hotel + Visa + Land + Cruise + Insurance + Land Profit + GST (5%) + TCS (if international) from Quotation</small> -->
                    </el-form-item>

                    <el-form-item label="Actual Hotel Cost" prop="hotel_cost" v-if="(enquiry.finalquotation && (enquiry.finalquotation.hotel_includes || form.hotel_cost>0)) || enquiry.is_hotel">
                        <el-input type="number" min="0" v-model="form.hotel_cost" @change="calculateconvertprofit" placeholder="Actual Hotel Cost" />
                    </el-form-item>

                    <el-form-item label="Actual Visa Cost" prop="visa_cost" v-if="(enquiry.finalquotation && (enquiry.finalquotation.is_visa || form.visa_cost>0)) || enquiry.is_visa">
                        <el-input type="number" min="0" v-model="form.visa_cost" @change="calculateconvertprofit" placeholder="Actual Visa Cost" />
                    </el-form-item>

                    <el-form-item label="Actual Land Cost" prop="land_cost" v-if="(enquiry.finalquotation && (enquiry.finalquotation.is_landpackage || form.land_cost>0)) || enquiry.is_landpackage">
                        <el-input type="number" min="0" v-model="form.land_cost" @change="calculateconvertprofit" placeholder="Actual Land Cost" />
                    </el-form-item>

                    <el-form-item label="Actual Cruise Cost" prop="cruise_cost" v-if="(enquiry.finalquotation && (enquiry.finalquotation.is_cruise || form.cruise_cost>0)) || enquiry.is_cruise">
                        <el-input type="number" min="0" v-model="form.cruise_cost" @change="calculateconvertprofit" placeholder="Actual Cruise Cost" />
                    </el-form-item>

                    <el-form-item label="Actual Travel Insurance Cost" prop="travel_insurance_cost" v-if="(enquiry.finalquotation && (enquiry.finalquotation.is_insurance || form.travel_insurance_cost>0)) || enquiry.is_insurance">
                        <el-input type="number" min="0" v-model="form.travel_insurance_cost" @change="calculateconvertprofit" placeholder="Actual Travel Insurance Cost" />
                    </el-form-item>

                    <el-form-item :label="'Package GST (' + (pricingRates.land_gst || 5) + '%)'">
                        <el-input type="number" v-model="form.land_gst" placeholder="Package GST" readonly />
                        <!-- <small class="el-form-item__hint">Base amount × 5/105 &nbsp; (Base = Pkg Total × 100/102 when TCS applies, else = Pkg Total)</small> -->
                    </el-form-item>

                    <el-form-item label="Package Profit">
                        <el-input type="number" v-model="form.land_profit" placeholder="Package Profit" readonly />
                        <!-- <small class="el-form-item__hint">Base amount × 100/105 − Sum of Actual Costs</small> -->
                    </el-form-item>
                </template>

                <!-- ══ SUMMARY ══ -->
                <el-divider content-position="left"><strong>Summary</strong></el-divider>

                <el-form-item label="Discount Type">
                    <el-select style="width:100%" v-model="form.discount_type" @change="calculateconvertprofit">
                        <el-option label="Percent (%)" value="percent"></el-option>
                        <el-option label="Amount (₹)" value="amount"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="form.discount_type === 'percent' ? 'Discount (%) of land before GST' : 'Discount off the customer total (₹)'" prop="discount_value">
                    <el-input type="number" min="0" step="0.01" v-model="form.discount_value" @change="calculateconvertprofit"
                        :placeholder="form.discount_type === 'percent' ? 'Percent of land before GST' : 'Rupees off the customer total'" />
                </el-form-item>
                <el-form-item :label="form.discount_type === 'amount' ? 'Discount off customer total' : 'Land discount'">
                    <el-input type="number" v-model="form.discount_amount" readonly />
                </el-form-item>
                <el-form-item label="Removed before GST">
                    <el-input type="number" v-model="form.pre_tax_discount" readonly />
                </el-form-item>
                <el-form-item label="Discount Reason" prop="discount_reason" :rules="discountReasonRules">
                    <el-input type="textarea" v-model="form.discount_reason"
                        placeholder="Required when discount is greater than 0" />
                </el-form-item>

                <el-form-item :label="'TCS (' + (pricingRates.tcs || 2) + '% of land after discount + land GST)'">
                    <el-input type="number" v-model="form.tds_cost" placeholder="TCS" readonly />
                </el-form-item>

                <el-form-item label="Total GST">
                    <el-input type="number" v-model="form.gst" placeholder="Total GST" readonly />
                </el-form-item>

                <el-form-item label="Total Profit">
                    <el-input type="number" v-model="form.profit" placeholder="Total Profit" readonly />
                </el-form-item>

                <el-form-item label="Customer total">
                    <el-input type="number" v-model="form.quote_price" placeholder="Customer total" readonly />
                </el-form-item>

            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="edit=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Save</el-button>
            </div>
        </template>
    </el-drawer>

    <el-drawer v-model="logs" direction="rtl" size="100%">
        <template #header>
            <h4>Pricing Details Logs</h4>
        </template>
        <template #default>
            <el-table :data="enquiry.pricedetaillogs" border style="width: 100%">
                <el-table-column prop="department" label="Department"  >

                </el-table-column>
                <el-table-column prop="user.name" label="User"  />
                <el-table-column prop="created_at" label="Created At" />
                <el-table-column prop="quote_price" label="Quote"  >
                    <template #default="scope">
                     {{scope.row.quote_price}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.quote_price<enquiry.pricedetaillogs[scope.$index+1].quote_price">{{scope.row.quote_price-enquiry.pricedetaillogs[scope.$index+1].quote_price}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.quote_price>enquiry.pricedetaillogs[scope.$index+1].quote_price">{{scope.row.quote_price-enquiry.pricedetaillogs[scope.$index+1].quote_price}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="hotel_cost" label="Hotel"  >
                    <template #default="scope">
                        {{scope.row.hotel_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.hotel_cost<enquiry.pricedetaillogs[scope.$index+1].hotel_cost">{{scope.row.hotel_cost-enquiry.pricedetaillogs[scope.$index+1].hotel_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.hotel_cost>enquiry.pricedetaillogs[scope.$index+1].hotel_cost">{{scope.row.hotel_cost-enquiry.pricedetaillogs[scope.$index+1].hotel_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="flight_cost" label="Flight"  >
                    <template #default="scope">
                        {{scope.row.flight_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.flight_cost<enquiry.pricedetaillogs[scope.$index+1].flight_cost">{{scope.row.flight_cost-enquiry.pricedetaillogs[scope.$index+1].flight_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.flight_cost>enquiry.pricedetaillogs[scope.$index+1].flight_cost">{{scope.row.flight_cost-enquiry.pricedetaillogs[scope.$index+1].flight_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="visa_cost" label="Visa"  >
                    <template #default="scope">
                        {{scope.row.visa_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.visa_cost<enquiry.pricedetaillogs[scope.$index+1].visa_cost">{{scope.row.visa_cost-enquiry.pricedetaillogs[scope.$index+1].visa_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.visa_cost>enquiry.pricedetaillogs[scope.$index+1].visa_cost">{{scope.row.visa_cost-enquiry.pricedetaillogs[scope.$index+1].visa_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="land_cost" label="Land"  >
                    <template #default="scope">
                        {{scope.row.land_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.land_cost<enquiry.pricedetaillogs[scope.$index+1].land_cost">{{scope.row.land_cost-enquiry.pricedetaillogs[scope.$index+1].land_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.land_cost>enquiry.pricedetaillogs[scope.$index+1].land_cost">{{scope.row.land_cost-enquiry.pricedetaillogs[scope.$index+1].land_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="cruise_cost" label="Cruise"  >
                    <template #default="scope">
                        {{scope.row.cruise_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.cruise_cost<enquiry.pricedetaillogs[scope.$index+1].cruise_cost">{{scope.row.cruise_cost-enquiry.pricedetaillogs[scope.$index+1].cruise_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.cruise_cost>enquiry.pricedetaillogs[scope.$index+1].cruise_cost">{{scope.row.cruise_cost-enquiry.pricedetaillogs[scope.$index+1].cruise_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="travel_insurance_cost" label="Insurance"  >
                    <template #default="scope">
                        {{scope.row.travel_insurance_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.travel_insurance_cost<enquiry.pricedetaillogs[scope.$index+1].travel_insurance_cost">{{scope.row.travel_insurance_cost-enquiry.pricedetaillogs[scope.$index+1].travel_insurance_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.travel_insurance_cost>enquiry.pricedetaillogs[scope.$index+1].travel_insurance_cost">{{scope.row.travel_insurance_cost-enquiry.pricedetaillogs[scope.$index+1].travel_insurance_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="tds_cost" label="TCS"  >
                    <template #default="scope">
                        {{scope.row.tds_cost}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.tds_cost<enquiry.pricedetaillogs[scope.$index+1].tds_cost">{{scope.row.tds_cost-enquiry.pricedetaillogs[scope.$index+1].tds_cost}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.tds_cost>enquiry.pricedetaillogs[scope.$index+1].tds_cost">{{scope.row.tds_cost-enquiry.pricedetaillogs[scope.$index+1].tds_cost}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="gst" label="GST" >
                    <template #default="scope">
                        {{scope.row.gst}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.gst<enquiry.pricedetaillogs[scope.$index+1].gst">{{scope.row.gst-enquiry.pricedetaillogs[scope.$index+1].gst}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.gst>enquiry.pricedetaillogs[scope.$index+1].gst">{{scope.row.gst-enquiry.pricedetaillogs[scope.$index+1].gst}}</el-tag>




                    </template>
                </el-table-column>
                <el-table-column prop="profit" label="Profit"  >
                    <template #default="scope">
                        {{scope.row.profit}}

                        <el-tag type="danger" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.profit<enquiry.pricedetaillogs[scope.$index+1].profit">{{scope.row.profit-enquiry.pricedetaillogs[scope.$index+1].profit}}</el-tag>
                        <el-tag type="success" size="small" v-if="scope.$index<enquiry.pricedetaillogs.length-1 && scope.row.profit>enquiry.pricedetaillogs[scope.$index+1].profit">{{scope.row.profit-enquiry.pricedetaillogs[scope.$index+1].profit}}</el-tag>




                    </template>
                </el-table-column>

            </el-table>
        </template>

    </el-drawer>
</template>

<script>
import {
    ElTable,ElTableColumn,ElCheckbox,ElCheckboxGroup,ElDatePicker,ElSelectV2,ElInputNumber,ElRadioGroup,ElRadio,ElDescriptionsItem,ElDescriptions,ElCard,ElTag,ElRow,ElCol,ElButton,ElDrawer,ElForm,ElFormItem,ElInput,ElSelect,ElOption,ElDivider
} from 'element-plus'
import { roundMoney } from '../../../utils/money'
import { applyDiscountBeforeTax, DEFAULT_PRICING_RATES } from '../../../utils/landPricing'
export default {
    name: "FinalPricingDetails",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElTable,ElTableColumn,ElCheckbox,ElCheckboxGroup,ElDatePicker,ElSelectV2,ElInputNumber,ElRadioGroup,ElRadio,ElDescriptionsItem,ElDescriptions,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,ElDrawer,ElForm,ElFormItem,ElInput,ElDivider },
    data() {
        return {
            loading:false,
            edit:false,
            logs:false,
            pricingRates: { ...DEFAULT_PRICING_RATES },
            tcsIncluded: false,
            form:{
                quote_price:0,
                hotel_cost:0,
                visa_cost:0,
                land_cost:0,
                flight_cost:0,
                cruise_cost:0,
                travel_insurance_cost:0,
                tds_cost:0,
                profit:0,
                gst:0,
                land_gst:0,
                flight_gst:0,
                land_profit:0,
                flight_profit:0,
                hotel_profit:0,
                transportation_cost:0,
                transportation_profit:0,
                backup_cost:0,
                service_cost:0,
                land_before_gst:0,
                pre_tax_discount:0,
                land_after_discount:0,
                land_gst_percent:5,
                tcs_percent:2,
                tcs_included:0,
                taxes_absorbed:0,
                helicopter_cost:0,
                helicopter_profit:0,
                helicopter_gst:0,
                helicopter_total:0,
                discount_type: 'percent',
                discount_value: 0,
                discount_amount: 0,
                discount_reason: '',
            },
            rules:{
                flight_cost:[{ required: true, message: 'Required', trigger: ['blur','change'] }],
                hotel_cost:[{ required: true, message: 'Required', trigger: ['blur','change'] }],
                visa_cost:[{ required: true, message: 'Required', trigger: ['blur','change'] }],
                land_cost:[{ required: true, message: 'Required', trigger: ['blur','change'] }],
                cruise_cost:[{ required: true, message: 'Required', trigger: ['blur','change'] }],
                travel_insurance_cost:[{ required: true, message: 'Required', trigger: ['blur','change'] }],
            }
        }
    },
    computed: {
        quotedFlightTotal() {
            const q = this.enquiry.finalquotation;
            if (!q) return 0;
            return parseFloat(q.flight_cost || 0)
                 + parseFloat(q.flight_gst || 0)
                 + parseFloat(q.flight_profit || 0);
        },
        quotedPackageTotal() {
            const q = this.enquiry.finalquotation;
            if (!q) return 0;
            const p = q.pricingdetails || {};
            const lc = p.landcascade || {};
            if (lc.package_total != null && lc.package_total !== '') {
                return parseFloat(lc.package_total || 0);
            }
            if (p.othertotal != null && p.othertotal !== '') {
                return parseFloat(p.othertotal || 0);
            }
            return parseFloat(q.hotel_cost || 0)
                + parseFloat(q.visa_cost || 0)
                + parseFloat(q.land_cost || 0)
                + parseFloat(q.cruise_cost || 0)
                + parseFloat(q.travel_insurance_cost || 0)
                + parseFloat(q.land_profit || 0)
                + parseFloat(q.non_flight_gst || 0)
                + parseFloat(q.tds_cost || 0);
        },
        packageDiscountBreakup() {
            const q = this.enquiry.finalquotation || {};
            const bd = this.enquiry.bookingdetails || {};
            const p = q.pricingdetails || {};
            const calc = p.calculation || {};
            const cascade = p.landcascade || {};
            const rates = p.rates_used || {};
            const landBefore = parseFloat(cascade.land_before_gst || bd.land_before_gst || calc.land_before_gst || 0) || 0;
            const gstPercent = parseFloat(calc.land_gst_percent || rates.land_gst || 5) || 0;
            const undiscountedGst = (cascade.land_gst !== undefined && cascade.land_gst !== null && cascade.land_gst !== '')
                ? parseFloat(cascade.land_gst) || 0
                : Math.round((Math.round(landBefore * 100) / 100) * gstPercent / 100);
            const chargedGst = parseFloat(
                (bd.land_gst !== undefined && bd.land_gst !== null && bd.land_gst !== '')
                    ? bd.land_gst
                    : (calc.land_gst || 0)
            ) || 0;
            const preTax = parseFloat(
                (bd.pre_tax_discount !== undefined && bd.pre_tax_discount !== null && bd.pre_tax_discount !== '')
                    ? bd.pre_tax_discount
                    : (calc.pre_tax_discount !== undefined && calc.pre_tax_discount !== null
                        ? calc.pre_tax_discount
                        : (bd.discount_amount || calc.discount_amount || q.discount_amount || 0))
            ) || 0;

            return {
                landDiscount: Math.max(0, preTax),
                gstDiscount: Math.max(0, undiscountedGst - chargedGst),
                type: bd.discount_type || calc.discount_type || q.discount_type || 'percent',
                value: bd.discount_value || calc.discount_value || q.discount_value || 0,
            };
        },
        salesProfit() {
            const bd = this.enquiry.bookingdetails || {};
            return (parseFloat(bd.flight_profit) || 0)
                + (parseFloat(bd.land_profit) || 0)
                + (parseFloat(bd.hotel_profit) || 0)
                + (parseFloat(bd.backup_cost) || 0)
                + (parseFloat(bd.service_cost) || 0);
        },
        hasPackage() {
            const q = this.enquiry.finalquotation;
            const e = this.enquiry;
            if (!q && !e) return false;
            return (q && (q.hotel_includes || q.is_visa || q.is_landpackage || q.is_cruise || q.is_insurance))
                || e.is_hotel || e.is_visa || e.is_landpackage || e.is_cruise || e.is_insurance
                || this.form.hotel_cost > 0 || this.form.visa_cost > 0 || this.form.land_cost > 0
                || this.form.cruise_cost > 0 || this.form.travel_insurance_cost > 0;
        },
        discountReasonRules() {
            return [
                {
                    validator: (rule, value, callback) => {
                        if (parseFloat(this.form.discount_amount || 0) > 0) {
                            if (!value || !String(value).trim()) {
                                callback(new Error('Discount reason is required when discount > 0'));
                                return;
                            }
                        }
                        callback();
                    },
                    trigger: ['blur', 'change'],
                },
            ];
        },
    },
    methods:{
        fmt(value) {
            return Intl.NumberFormat('en-US').format(Math.round(parseFloat(value) || 0));
        },
        editdet(){
            const q  = this.enquiry.finalquotation || {};
            const bd = this.enquiry.bookingdetails;

            const p = q.pricingdetails || {};
            const rates = { ...DEFAULT_PRICING_RATES, ...(p.rates_used || {}) };
            if (p.tax_application) {
                rates.taxes_absorbed = p.tax_application === 'absorbed' ? 1 : 0;
            }
            this.pricingRates = rates;
            this.tcsIncluded = p.tcsincluded != null
                ? !!p.tcsincluded
                : (parseFloat(q.tds_cost || 0) > 0 || this.enquiry.dest_team === 'International');

            this.form.quote_price = parseFloat(bd.quote_price || q.quote_price || 0);
            this.form.flight_cost           = parseFloat(bd.flight_cost            || 0);
            this.form.hotel_cost            = parseFloat(bd.hotel_cost             || 0);
            this.form.visa_cost             = parseFloat(bd.visa_cost              || 0);
            this.form.land_cost             = parseFloat(bd.land_cost              || 0);
            this.form.cruise_cost           = parseFloat(bd.cruise_cost            || 0);
            this.form.travel_insurance_cost = parseFloat(bd.travel_insurance_cost  || 0);
            const quoteCalc = (q.pricingdetails && q.pricingdetails.calculation) || {};
            const quoteDiscountValue = parseFloat(
                (q.discount_value !== undefined && q.discount_value !== null && q.discount_value !== '')
                    ? q.discount_value
                    : (quoteCalc.discount_value || 0)
            ) || 0;
            const bookingDiscountValue = parseFloat(bd.discount_value || 0) || 0;
            if (bookingDiscountValue > 0) {
                this.form.discount_type = bd.discount_type || 'percent';
                this.form.discount_value = bookingDiscountValue;
            } else if (quoteDiscountValue > 0) {
                this.form.discount_type = (q.discount_type || quoteCalc.discount_type) === 'amount' ? 'amount' : 'percent';
                this.form.discount_value = quoteDiscountValue;
            } else {
                this.form.discount_type = 'percent';
                this.form.discount_value = 0;
            }
            this.form.discount_amount       = parseFloat(bd.discount_amount || 0);
            this.form.discount_reason       = bd.discount_reason || '';
            this.form.flight_gst            = parseFloat(bd.flight_gst || q.flight_gst || 0);
            this.form.flight_profit         = parseFloat(bd.flight_profit || q.flight_profit || 0);
            this.form.land_profit           = parseFloat(bd.land_profit || q.land_profit || 0);
            this.form.land_gst              = parseFloat(bd.land_gst || q.non_flight_gst || 0);

            const lc = (q.pricingdetails && q.pricingdetails.landcascade) ? q.pricingdetails.landcascade : {};
            this.form.hotel_profit = parseFloat(bd.hotel_profit || lc.hotel_profit || q.hotel_profit || 0);
            this.form.transportation_cost = parseFloat(bd.transportation_cost || lc.transportation_cost || q.transportation_cost || 0);
            this.form.transportation_profit = parseFloat(bd.transportation_profit || lc.transportation_profit || q.transportation_profit || 0);
            this.form.backup_cost = parseFloat(bd.backup_cost || lc.backup_cost || q.backup_cost || 0);
            this.form.service_cost = parseFloat(bd.service_cost || lc.service_cost || q.service_cost || 0);
            this.form.land_before_gst = parseFloat(bd.land_before_gst || lc.land_before_gst || q.land_before_gst || 0);
            const hc = (q.pricingdetails && q.pricingdetails.helicoptercascade) ? q.pricingdetails.helicoptercascade : {};
            this.form.helicopter_cost = parseFloat(bd.helicopter_cost || hc.helicopter_cost || q.helicopter_cost || 0);
            this.form.helicopter_profit = parseFloat(bd.helicopter_profit || hc.helicopter_profit || q.helicopter_profit || 0);
            this.form.helicopter_gst = parseFloat(bd.helicopter_gst || hc.helicopter_gst || q.helicopter_gst || 0);
            this.form.helicopter_total = parseFloat(bd.helicopter_total || hc.helicopter_total || q.helicopter_total || 0);

            this.calculateconvertprofit();
        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return;
            formEl.validate((valid) => {
                if (valid) {
                    const charged = applyDiscountBeforeTax({
                        landBeforeGst: this.form.land_before_gst,
                        tcsIncluded: !!this.tcsIncluded,
                        landGstPercent: this.pricingRates.land_gst,
                        tcsPercent: this.pricingRates.tcs,
                        discountType: this.form.discount_type,
                        discountValue: this.form.discount_value,
                        taxesAbsorbed: Number(this.pricingRates.taxes_absorbed) === 1,
                    });
                    if (charged.discount_error) {
                        toastr.error(charged.discount_error);
                        return false;
                    }
                    this.save();
                } else {
                    return false;
                }
            });
        },
        save(){
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/enquiry/savepricedetails?id='+this.enquiry.id, this.form).then(function (response) {
                toastr.success('Details Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.loading=false;
                currentObj.edit=false;
            }).catch(function (error) {
                currentObj.loading=false;
                const msg = error?.response?.data?.error;
                toastr.error(msg || 'Something Wrong try again.');
            });
        },
        calculateconvertprofit(){
            const rates = this.pricingRates || DEFAULT_PRICING_RATES;
            const taxesAbsorbed = Number(rates.taxes_absorbed) === 1;
            const charged = applyDiscountBeforeTax({
                landBeforeGst: this.form.land_before_gst || 0,
                tcsIncluded: !!this.tcsIncluded,
                landGstPercent: rates.land_gst,
                tcsPercent: rates.tcs,
                discountType: this.form.discount_type,
                discountValue: this.form.discount_value,
                taxesAbsorbed,
            });
            if (charged.discount_error) {
                toastr.warning(charged.discount_error);
            }
            if (!charged.discount_error && charged.discount_amount <= 0) {
                this.form.discount_reason = '';
            }

            const flightFare = roundMoney(this.form.flight_cost);
            const flightService = roundMoney(this.form.flight_profit);
            const flightGst = roundMoney(this.form.flight_gst);
            const heliBefore = roundMoney(
                (parseFloat(this.form.helicopter_cost) || 0) + (parseFloat(this.form.helicopter_profit) || 0)
            );
            const heliGst = roundMoney(this.form.helicopter_gst);
            const extras = taxesAbsorbed
                ? roundMoney(flightFare + flightService + heliBefore)
                : roundMoney(flightFare + flightService + flightGst + heliBefore + heliGst);

            this.form.discount_amount = charged.discount_amount;
            this.form.pre_tax_discount = charged.pre_tax_discount;
            this.form.land_after_discount = charged.land_after_discount;
            this.form.land_gst = charged.land_gst;
            this.form.tds_cost = charged.tcs;
            this.form.land_gst_percent = Number(rates.land_gst) || 0;
            this.form.tcs_percent = Number(rates.tcs) || 0;
            this.form.tcs_included = this.tcsIncluded ? 1 : 0;
            this.form.taxes_absorbed = taxesAbsorbed ? 1 : 0;
            this.form.gst = roundMoney(charged.land_gst + flightGst + heliGst).toFixed(2);
            this.form.profit = roundMoney(
                (parseFloat(this.form.land_profit) || 0) + flightService + (parseFloat(this.form.helicopter_profit) || 0)
            ).toFixed(2);
            this.form.quote_price = roundMoney(charged.customer_total + extras);
        },
    }
}
</script>

<style scoped>
.pricing-section-title {
    font-weight: 600;
    font-size: 13px;
    color: #409eff;
    padding: 6px 0 4px 0;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 6px;
}
.el-form-item__hint {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
    display: block;
}
</style>
